import React, { Component } from 'react';
import propTypes from 'prop-types';
import { MainContent, Content } from 'client/components/App';
import { Helmet } from 'react-helmet';
import { AppSparklinesBar } from 'client/components/Helpers/Sparklines';
import ConnectedMWTDWidgetStatistic from 'client/components/MWTD/ConnectedMWTDWidgetStatistic';
import ConnectedMWTDOptionsForm from 'client/components/MWTD/ConnectedMWTDOptionsForm';
import ConnectedMWTDTester from 'client/components/MWTD/ConnectedMWTDTester';
import InstanceWidgetPlan from 'client/components/Instance/components/InstanceWidgetPlan';
import InstanceWidgetControls from 'client/components/Instance/components/InstanceWidgetControls';
import InstanceDashboard from 'client/components/Instance/InstanceDashboard';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import InstanceParentAlert from 'client/components/Instance/components/InstanceParentAlert';

class ConnectedMWTDModule extends Component {

  static propTypes = {
    instanceId: propTypes.string.isRequired,
    tab: propTypes.string.isRequired,
  };

  handleSelectTab = newTab => {
    if (newTab === this.props.tab) return;
    const instanceId = this.props.instanceId;
    this.props.push(`/instance/mwtd/${instanceId}/${newTab}`);
  };

  render () {
    const instanceId = this.props.instanceId;
    return (
      <Content>
        <Helmet>
          <title>Barracuda Managed Workplace → TOPdesk</title>
        </Helmet>
        <MainContent>
          <InstanceParentAlert />
          <div className="row">
            <div className="col-xs-12 col-md-6 col-lg-3">
              <ConnectedMWTDWidgetStatistic
                title="Actions per month"
                id={instanceId}
                statistic="logSummer"
                query={{duration: 'month', limit: 7}}
                Component={AppSparklinesBar}
              />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3">
              <ConnectedMWTDWidgetStatistic
                title="Number of tasks in queue"
                id={instanceId}
                statistic="messagesInOwnQueue"
              />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3">
              <InstanceWidgetPlan
                id={instanceId}
                shouldReadInstance={false}
              />
            </div>
            <div className="col-xs-12 col-md-6 col-lg-3">
              <InstanceWidgetControls
                id={instanceId}
                shouldReadInstance={false}
              />
            </div>
          </div>
          <InstanceDashboard
            id={this.props.instanceId}
            tab={this.props.tab}
            OptionsFormComponent={ConnectedMWTDOptionsForm}
            TesterComponent={ConnectedMWTDTester}
            onSelectTab={this.handleSelectTab}
            endpointOrder={['managedworkplace', 'topdesk']}
          />
        </MainContent>
      </Content>
    );
  }

}

const actions = {
  push,
};

export default connect(null, actions)(ConnectedMWTDModule);
